// Leaflet interpreta un string como HTML (bindTooltip, bindPopup): los datos
// importados o tipeados (tracking, cliente, direcciones, tiendas, resultados
// del buscador) van siempre como texto, nunca concatenados en un string.
export function textTooltip(text: string): HTMLElement {
  const element = document.createElement("span");
  element.textContent = text;
  return element;
}
